import { render, staticRenderFns } from "./phase_item.vue?vue&type=template&id=3b1e55d8&scoped=true&"
import script from "./phase_item.vue?vue&type=script&lang=js&"
export * from "./phase_item.vue?vue&type=script&lang=js&"
import style0 from "./phase_item.vue?vue&type=style&index=0&id=3b1e55d8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b1e55d8",
  null
  
)

export default component.exports